import ManageHeader from "@components/ManageHeader";
import { LucideChevronRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import contact from "../../assets/contact.webp"
import sales from "../../assets/sales.jpg"
import media from "../../assets/media.jpg"
import support from "../../assets/support.jpg"
import partner from "../../assets/partner.jpg"

function Contact(props) {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    service: '',
    phone: '',
    message: '',
    name: '',
    email: ''
  });
  const formRef = useRef(null);
  useEffect(() => {
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [showForm]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Add your form submission logic here
  };

  const contactCards = [
    {
      title: "Talk to Sales",
      description: "Chat with our team and let us help you start your activity ASAP.",
      buttonText: "Get support",
      type: "sales",
      img: sales
    },
    {
      title: "Talk to Support",
      description: "Talk with a real and live human or self-serve using our help centre.",
      buttonText: "Get support",
      type: "support",
      img: support
    },
    {
      title: "Talk to Media",
      description: "Send us a note and our PR and communications manager will be in touch.",
      buttonText: "Get in touch",
      type: "media",
      img: media
    },
    {
      title: "Talk to Partnerships",
      description: "Fill out the form here and our partnerships manager will circle back.",
      buttonText: "Get in touch",
      type: "partnerships",
      img: partner
    }
  ];

  const handleCardClick = (type) => {
    setFormData(prev => ({
      ...prev,
      service: type
    }));

    if (!showForm) {
      // Si le formulaire n'était pas visible, on l'affiche → useEffect fera le scroll
      setShowForm(true);
    } else if (formRef.current) {
      // Si le formulaire est déjà visible, scroll directement
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  return (

    <>

      <div className="position-relative" style={{ background: "#F5F5F5" }}>
        <div className="container-xl pt-5 "  >
          <div className="row py-5 mt-5">
            <Col sm={12} md={6}>
              <h1 className="mb-4  fw-bold" style={{ fontSize: "60px" }}>{t('contact_title')}</h1>
              <p className="fw-medium">
                {t('contact_paragraph')}
              </p>
              <p className="fw-semibold">
                {t('contact_response')}
              </p>
            </Col>
            <Col sm={12} md={6}>
              <img src={contact} className="img-fluid" />
            </Col>
          </div>

        </div>
      </div>
      <div className="container-xl">

        <div className="row p-4 mt-4">
          {contactCards.map((card, index) => (
            <Col sm={12} md={4} key={index} className="mb-4 d-flex">
              <div className="rounded-4 p-3 w-100 d-flex flex-column "
                style={{ transition: "all 0.3s" }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f0e9e9"}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = ""}>

                {/* Image full width */}
                {card.img && (
                  <img
                    src={card.img}
                    alt={card.title}
                    className="img-fluid rounded-4 w-100"
                    style={{ objectFit: "cover" }}
                  />
                )}

                {/* Card body */}
                <div className="p-4 d-flex flex-column flex-grow-1">
                  {/* Title */}
                  <h3>{card.title}</h3>

                  {/* Description */}
                  <p className="flex-grow-1">
                    {card.description}
                  </p>

                  {/* Button */}
                  <button
                    className={`p-3 rounded-5 mt-auto ${formData.service === card.type ? 'btn-outline-blue' : 'btn-blue'}`}
                    onClick={() => handleCardClick(card.type)}
                  >
                    {t(card.buttonText)}
                    <LucideChevronRight className="ms-2" />
                  </button>
                </div>

              </div>
            </Col>
          ))}
        </div>

        <div className="row">


          {/* Right Column - Contact Form */}
          {showForm && (
            <div className="" ref={formRef}>
              <div className="bg-white p-4 rounded">

                <div className="card-body pt-4">
                  <form onSubmit={handleSubmit}>

                    <div className="row mb-3">
                      <div className=" col-sm-4">
                        <label htmlFor="service" className="form-label">
                          {t("service")} *
                        </label>
                        <select
                          id="service"
                          name="service"
                          className="form-select"
                          value={formData.service}
                          onChange={handleChange}
                          required
                        >
                          <option value="sales">{t("sales")}</option>
                          <option value="support">{t("support")}</option>
                          <option value="media">{t("media")}</option>
                          <option value="partnerships">{t("partnerships")}</option>
                        </select>
                      </div>
                      <div className="col-sm-4">
                        <label htmlFor="name" className="form-label">
                          {t("name")} *
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder={t("enter_your_name")}
                          required
                        />
                      </div>
                      <div className="col-sm-4">
                        <label htmlFor="email" className="form-label">
                          {t("email")} *
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder={t("enter_your_email")}
                          required
                        />
                      </div>
                    </div>


                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">
                        {t("message")} *
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        className="form-control"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder={t("enter_your_message")}
                        required
                      ></textarea>
                    </div>



                    <div className="mt-4">
                      <button type="submit" className="btn btn-primary ">
                        {t("submit")}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

    </>
  );
}
export default Contact;